import { generateSizes, generateSrcSet, isOptimizableUrl } from 'core/utils/imageOptimization';
import { useEffect, useState } from 'react';

// Tamaños de imagen disponibles (debe coincidir con IMAGE_SIZES en imageOptimization.js)
const IMAGE_SIZES = [50, 400, 800, 1280];

function useImage({ src, srcSet, disableOptimization, responsiveSizes, sizes }) {
  const [maxSizeIndex, setMaxSizeIndex] = useState(0);

  // Reset maxSizeIndex cuando cambia el src
  useEffect(() => {
    setMaxSizeIndex(0);
  }, [src]);

  // Detectar si es URL local (no optimizable)
  const isLocalUrl = src ? !isOptimizableUrl(src) : false;

  // Si hay srcSet manual o está deshabilitada la optimización, usar directamente
  if (srcSet || disableOptimization || !src || isLocalUrl) {
    return {
      imageSrc: src || '',
      imageSrcSet: srcSet || '',
      sizesString: sizes || '',
      handleImageError: () => {},
    };
  }

  // Generar srcSet con exclusión progresiva según maxSizeIndex
  const generatedSrcSet = generateSrcSet(src, undefined, maxSizeIndex);

  // Determinar si se agotaron todos los tamaños
  const hasExhaustedAllSizes = maxSizeIndex >= IMAGE_SIZES.length;

  // Generar sizes string solo si hay srcSet generado
  // Si se agotaron todos los tamaños, no incluir sizes
  const sizesString = hasExhaustedAllSizes ? '' : sizes || generateSizes(responsiveSizes);

  // Handler de error que incrementa maxSizeIndex para excluir tamaños grandes progresivamente
  // Los tamaños están ordenados de menor a mayor: [50, 400, 800, 1280]
  // maxSizeIndex = 0: incluye todos [50, 400, 800, 1280]
  // maxSizeIndex = 1: excluye 1280 → [50, 400, 800]
  // maxSizeIndex = 2: excluye 800, 1280 → [50, 400]
  // maxSizeIndex = 3: excluye 400, 800, 1280 → [50]
  // maxSizeIndex = 4: excluye todos → [] (usar original)
  const handleImageError = () => {
    if (!src || isLocalUrl) return;

    if (maxSizeIndex < IMAGE_SIZES.length) {
      setMaxSizeIndex(maxSizeIndex + 1);
    }
  };

  return {
    imageSrc: src,
    imageSrcSet: hasExhaustedAllSizes ? '' : generatedSrcSet || '',
    sizesString,
    handleImageError,
  };
}

export default useImage;
